module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h2', [_vm._v(_vm._s(_vm.headline))]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, _vm._l((_vm.contents), function(item, index) {
    return _c('li', [_c('a', {
      staticClass: "nav-link",
      class: _vm.getClassObject(index),
      attrs: {
        "data-item-index": index,
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeContent($event)
        }
      }
    }, [_vm._v(_vm._s(item.language))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.ismultiline) ? _c('erco-text-area', {
    attrs: {
      "text": _vm.contents[_vm.currentContentIndex].text
    }
  }) : _c('erco-text-input', {
    attrs: {
      "text": _vm.contents[_vm.currentContentIndex].text
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-665a72f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/ErcoTextEditor.vue
// module id = 629
// module chunks = 0